import { render, staticRenderFns } from "./SyllabusListComments.vue?vue&type=template&id=7310cf48&"
import script from "./SyllabusListComments.vue?vue&type=script&lang=js&"
export * from "./SyllabusListComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports